module.exports = __webpack_public_path__ + "img/64.69e3e5ac.jpg";